export const getBrandsAndProducts = (categories, selected) => {
  const brandsList = [];
  const productsList = [];
  const keysArrayOfSelected = [...selected.keys()].filter(key => selected.get(key));
  categories.forEach(category =>
    category.families.forEach(family =>
      family.brands.forEach(brand => {
        if (
          brandsList.findIndex(brandPushed => brand.brandId === brandPushed.id) === -1 &&
          keysArrayOfSelected.findIndex(key => key === `brand-${brand.brandId}`) > -1
        ) {
          brandsList.push({ label: brand.label, id: brand.brandId });
        }
        brand.products.forEach(product => {
          if (keysArrayOfSelected.findIndex(key => key === `product-${product.ean}`) > -1) {
            productsList.push({
              id: `product-${product.ean}`,
              label: product.label,
              client_product_id: product.client_product_id,
              ean: product.ean,
              brandId: brand.brandId,
              brandLabel: brand.label,
              familyId: family.familyId,
              familyLabel: family.label,
              categoryId: category.categoryId,
              categoryLabel: category.label
            });
            if (
              // ajout de la marque du produit a la liste des marques
              brandsList.findIndex(brandPushed => brand.brandId === brandPushed.id) === -1
            ) {
              brandsList.push({ label: brand.label, id: brand.brandId });
            }
          }
        });
      })
    )
  );

  return { brands: brandsList, products: productsList };
};



// WEBPACK FOOTER //
// src/components/phototheque/phototheque.utils.js